import React, {
  FunctionComponent,
  useMemo,
} from 'react';
import {useSelector} from 'react-redux';

import {IState} from '../../store/reducers';
import {IUser} from '../../models';
import {isAdmin, isUser} from '../../utils/auth';
import {UserLimitContextProvider} from './hooks/use-user-limit';
import {useCurrentWorkspace} from "../../hooks";

interface IUserLimitContainerProps {
  children: any;
}

const UserLimitContainer: FunctionComponent<IUserLimitContainerProps> = ({
  children
}: IUserLimitContainerProps) => {
  /*
   * This is a HOC that wraps a Context Provider
   */
  const currentWorkspace = useCurrentWorkspace();
  const users = useSelector((state: IState) => state.users.users);
  const totalUsers = useMemo(() => users?.length || 0, [users?.length]);

  const totalAdminUsers = useMemo(() => {
    return users?.filter((user: IUser) => isAdmin(user))?.length || 0;
  }, [users]);

  const totalUserUsers = useMemo(() => {
    return users?.filter((user: IUser) => isUser(user))?.length || 0;
  }, [users]);

  const usersLimit = useMemo(() => {
    return currentWorkspace?.organization?.subscription_json?.plan?.limit?.user || 0;
  }, [currentWorkspace]);

  return (
    <UserLimitContextProvider
      totalUsers={totalUsers}
      totalAdminUsers={totalAdminUsers}
      totalUserUsers={totalUserUsers}
      usersLimit={usersLimit}
    >
      {children}
    </UserLimitContextProvider>
  )
}

export default UserLimitContainer;
